import React, { useMemo, useState } from "react";
import { Badge, Box, HStack, Input, Text, VStack } from "@chakra-ui/react";
import { STATUS_META } from "../../utils/workItemStatus";

const KIND_LABEL = { task: "Task", order: "Order", followup: "Follow-up" };

// The 📋 list in the message box: one of your tasks or orders (as the Tasks
// tab has them), open ones first, filtered by what you type.
export default function WorkItemLinkPicker({ items, onPick }) {
  const [query, setQuery] = useState("");
  const shown = useMemo(() => {
    const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
    const isOpen = (i) => !i.done;
    return (items || [])
      .filter((i) => !i.cancelled)
      .filter((i) => {
        const hay = `${i.title || ""} ${i.patientName || ""}`.toLowerCase();
        return words.every((w) => hay.includes(w));
      })
      .sort((a, b) => Number(isOpen(b)) - Number(isOpen(a)))
      .slice(0, 50);
  }, [items, query]);

  return (
    <VStack align="stretch" spacing={2}>
      <Input size="sm" placeholder="Find a task or order..." value={query} autoFocus
             onChange={(e) => setQuery(e.target.value)} />
      <VStack align="stretch" spacing={0} maxH="240px" overflowY="auto">
        {shown.length === 0 && <Text fontSize="sm" color="gray.500" p={2}>No tasks or orders match</Text>}
        {shown.map((i) => (
          <Box key={i.key} as="button" type="button" textAlign="left" px={2} py={1.5} borderRadius="md"
               _hover={{ bg: "gray.50" }} data-testid={`link-pick-${i.key}`} onClick={() => onPick(i)}>
            <HStack spacing={2}>
              <Badge fontSize="2xs" colorScheme={i.kind === "order" ? "blue" : "purple"}>
                {KIND_LABEL[i.kind === "order" ? i.orderType : "task"] || "Order"}
              </Badge>
              <Text fontSize="sm" noOfLines={1}>{i.title}</Text>
            </HStack>
            <Text fontSize="xs" color="gray.500" noOfLines={1}>
              {[i.patientName, STATUS_META[i.status]?.label, i.assigneeName && `→ ${i.assigneeName}`]
                .filter(Boolean).join(" · ")}
            </Text>
          </Box>
        ))}
      </VStack>
    </VStack>
  );
}
